import { render, staticRenderFns } from "./epic_token.vue?vue&type=template&id=8b6fbd20&"
import script from "./epic_token.vue?vue&type=script&lang=js&"
export * from "./epic_token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports